import Header from '../components/Header';
import Menu from '../components/Header/components/Menu';
import Notification from '../components/Notification';
import { TGameInfo } from '../components/Header/components/GameInfo';

const Layout = ({
  gameInfo,
  children,
}: {
  gameInfo?: TGameInfo;
  children?: React.ReactNode;
}) => {
  return (
    <div className="flex h-full flex-col">
      <Header gameInfo={gameInfo} />
      <main className="min-h-0 flex flex-1 flex-col items-center px-4 pt-6 pb-14">
        {children}
      </main>
      <Notification />
      <Menu numPlayers={gameInfo?.numPlayers || 0} />
    </div>
  );
};

export default Layout;
